






import { Component, Prop } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'

@Component
export default class AtomReadingNumber extends ComponentVue {
  @Prop({ type: Number, default: 0 })
  number!: boolean
}
